module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("默认(打开)")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch')], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("默认(关闭)")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch', {
    attrs: {
      "value": false
    }
  })], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("带文字")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch', {
    attrs: {
      "value": false,
      "show-tag": true
    }
  })], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("自定义文字")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch', {
    attrs: {
      "show-tag": true,
      "tag": ['ON', 'OFF']
    }
  })], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("异步修改状态")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch', {
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0eeca488!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-switch/demo.vue
// module id = 222
// module chunks = 30